<template>
	<div>
		<div v-if="!isMobile && websiteInfo.isArea" class="side-box">
			<div class="side-box-section">
				<div class="title"></div>
				<div class="area-content">
					<div class="item">
						<el-select v-model="provinceIndex" placeholder="请选择省" size="medium" style="width:100%">
							<el-option v-for="(item,index) in provinceList" :key="index" :label="item.label" :value="index"></el-option>
						</el-select>
					</div>
					<div class="item">
						<el-select v-model="cityIndex" placeholder="请选择市" size="medium" style="width:100%">
							<el-option v-for="(item,index) in cityList" :key="index" :label="item.label" :value="index"></el-option>
						</el-select>
					</div>
					<div class="item">
						<el-select v-model="areaIndex" placeholder="请选择区" size="medium" style="width:100%">
							<el-option v-for="(item,index) in areaList" :key="index" :label="item.label" :value="index"></el-option>
						</el-select>
					</div>
					<div class="item item-btn">
						<div class="btn btn-reset" @click="doReset">重置</div>
						<div class="btn btn-search" @click="doSearch">查询</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="websiteInfo.isArea" v-show="show">
			<div class="m-area-popup">
				<div class="title"></div>
				<div class="m-area-content">
					<div class="item">
						<el-select v-model="provinceIndex" placeholder="请选择省" style="width: 100%">
							<el-option v-for="(item,index) in provinceList" :key="index" :label="item.label" :value="index"></el-option>
						</el-select>
						<select v-model="provinceIndex" class="select-control">
							<option></option>
							<option v-for="(item,index) in provinceList" :key="index" :value="index">{{ item.label }}</option>
						</select>
					</div>
					<div class="item">
						<el-select v-model="cityIndex" placeholder="请选择市" style="width: 100%">
							<el-option v-for="(item,index) in cityList" :key="index" :label="item.label" :value="index"></el-option>
						</el-select>
						<select v-model="cityIndex" class="select-control">
							<option></option>
							<option v-for="(item,index) in cityList" :key="index" :value="index">{{ item.label }}</option>
						</select>
					</div>
					<div class="item">
						<el-select v-model="areaIndex" placeholder="请选择区" style="width: 100%">
							<el-option v-for="(item,index) in areaList" :key="index" :label="item.label" :value="index"></el-option>
						</el-select>
						<select v-model="areaIndex" class="select-control">
							<option></option>
							<option v-for="(item,index) in areaList" :key="index" :value="index">{{ item.label }}</option>
						</select>
					</div>
					<div class="item item-btn">
						<div class="btn btn-reset" @click="doReset">重置</div>
						<div class="btn btn-search" @click="doSearch">查询</div>
					</div>
				</div>
			</div>
			<div class="m-area-popup-mask" @click="$emit('update:show', false)"></div>
		</div>
	</div>
</template>

<script>
	/* global BMapGL */
	import {regionData} from 'element-china-area-data'

	export default {

		props: {
			map: {
				type:Object,
				default:()=>({})
			},
			show: Boolean
		},

		inject: ['getBoundary'],

		data() {
			return {
				provinceList: regionData,
				provinceIndex: '',
				cityIndex: '',
				areaIndex: '',
				polygon: null,
				isShowAreaPopup: false
			}
		},

		computed: {
			cityList() {
				return typeof this.provinceIndex == 'number' ? this.provinceList[this.provinceIndex].children : []
			},
			areaList() {
				return typeof this.cityIndex == 'number' ? this.cityList[this.cityIndex].children : []
			},
			areaDetail() {
				return typeof this.areaIndex == 'number' ? this.areaList[this.areaIndex].remark : ''
			},
			province() {
				return typeof this.provinceIndex == 'number' ? this.provinceList[this.provinceIndex].label : ''
			},
			city() {
				return typeof this.cityIndex == 'number' ? this.cityList[this.cityIndex].label : ''
			},
			area() {
				return typeof this.areaIndex == 'number' ? this.areaList[this.areaIndex].label : ''
			},
			websiteInfo() {
				return this.$store.state.user.websiteInfo || {}
			}
		},

		watch: {
			provinceIndex() {
				this.cityIndex = '';
				this.areaIndex = '';
			},
			cityIndex() {
				this.areaIndex = '';
			}
		},

		created() {
		},

		methods: {

			//查询边界-省市区查询
			async doSearch() {
				if (!this.province) {
					this.$message.error('省级必须选择')
					return
				}
				try {
					let address = this.province + this.city + this.area;
					let boundary = await this.getBoundary(address);
					let center = this.map.getViewport(boundary);
					this.map.centerAndZoom(center.center, center.zoom);
					this.polygon && this.map.removeOverlay(this.polygon);
					this.polygon = new BMapGL.Polygon(boundary, {fillOpacity: 0, strokeColor: '#666'});
					this.map.addOverlay(this.polygon);
					this.$emit('update:show', false);
				} catch (e) {
					console.error(e)
				}
			},

			//查询边界-重置
			doReset() {
				this.provinceIndex = '';
				this.cityIndex = '';
				this.areaIndex = '';
				this.polygon && this.map.removeOverlay(this.polygon);
				this.map.reset();
				this.$emit('update:show', false);
			},

		}
	}
</script>

<style scoped>
	.side-box {
		position: absolute;
		top: 100px;
		left: 20px;
		z-index: 100;
		width: 200px;
		display: flex;
		flex-direction: column;
	}

	.side-box-section {
		background: #fff;
		border-radius: 4px;
		box-shadow: 1px 1px 10px 1px #999;
	}

	.side-box-section .title {
		height: 50px;
		background: url("../../../assets/images/text-quyu.png") center center no-repeat;
		background-size: auto 18px;
		border-bottom: 1px solid #ededed;
	}

	.area-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px 10px;
	}

	.area-content .item {
		margin-bottom: 10px;
	}

	.area-content .item:last-child {
		margin-bottom: 0;
	}

	.area-content .item-btn {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 180px;
	}

	.area-content .btn {
		width: 85px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.area-content .btn:hover {
		opacity: 0.8;
	}

	.area-content .btn-search {
		background: #54877b;
		color: #fff;
	}

	.area-content .btn-reset {
		background: #ececec;
		color: #999;
	}

	.m-area-popup-mask {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 1000;
		background: #000;
		opacity: 0;
		animation: fadeIn 0.30s ease;
		animation-fill-mode: forwards;
	}

	@keyframes fadeIn {
		form {
			opacity: 0;
		}
		to {
			opacity: 0.5;
		}
	}

	.m-area-content {
		padding: 0 30px;
	}

	.m-area-content .item {
		margin-bottom: 15px;
		position: relative;
	}

	.m-area-content .select-control {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}

	.m-area-popup {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		background: #fff;
		z-index: 1001;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
		padding: 15px 0;
		transform: translateY(100%);
		animation: moveInBottom 0.30s ease;
		animation-fill-mode: forwards;
	}

	@keyframes moveInBottom {
		form {
			transform: translateY(100%);
		}
		to {
			transform: translateY(0);
		}
	}

	.m-area-popup .title {
		height: 60px;
		background: url("../../../assets/images/text-quyu.png") center center no-repeat;
		background-size: auto 20px;
	}

	.m-area-content .item-btn {
		display: flex;
		justify-content: space-between;
	}

	.m-area-content .btn {
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		cursor: pointer;
		width: 45%;
	}

	.m-area-content .btn:hover {
		opacity: 0.8;
	}

	.m-area-content .btn-search {
		background: #54877b;
		color: #fff;
	}

	.m-area-content .btn-reset {
		background: #ececec;
		color: #999;
	}

	.m-area-content .btn-position {
		background: #f7c772;
		color: #333;
	}

</style>